export const POLL_MS = 15_000;
export const TEAM_SCREEN_POLL_MS = 60_000;
